import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type TrackTagUpdated } from '../types';

export const useTrackTagRenamed = () => {
  const { track } = useAnalyticsUtilities();

  const trackTagRenamed = useCallback(
    (params: TrackTagUpdated) => {
      track(`Tag renamed`, params);
    },
    [track],
  );

  return { trackTagRenamed };
};
